import { Injectable, signal } from '@angular/core';

import { AppInfoConfig, PromoApiService } from '@frontend/vanilla/core';
import { Action, ActionCreator, MemoizedSelector, Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

import { TargetPromotionRequest } from '../models/target-promotion-request';

@Injectable({
    providedIn: 'root',
})
export class TargetPromotionService {
    optinClick$ = signal<boolean>(false);
    rewardCacheInformation$ = new BehaviorSubject<any>({});
    offerStatus$ = new BehaviorSubject('');
    constructor(
        private store: Store,
        private appInfo: AppInfoConfig,
        private apiService: PromoApiService,
    ) {}

    loadTargetPromotionDetails(
        promoId: string,
        isMetaDataLoadedSelector: MemoizedSelector<object, boolean>,
        targetPromotionRequestAction: ActionCreator<string, (props: TargetPromotionRequest) => TargetPromotionRequest & Action>,
    ) {
        this.store
            .select(isMetaDataLoadedSelector)
            .pipe(take(1))
            .subscribe((isMetaDataLoaded: boolean) => {
                if (!isMetaDataLoaded) {
                    const request = new TargetPromotionRequest();
                    request.promoId = promoId;
                    request.requestType = '';
                    this.store.dispatch(targetPromotionRequestAction(request));
                }
            });
    }

    getRewardsCache(key: string): any {
        const request = { cacheKey: key, brandId: this.appInfo.brand };
        this.apiService.get('getCache', null, { params: request, showSpinner: true }).subscribe((res) => {
            if (res) {
                this.rewardCacheInformation$.next(res);
            }
        });
    }

    setRewardCache(key: string, featureKey?: string) {
        const request = { cacheKey: key, value: true, brandId: this.appInfo.brand, feature: featureKey };
        this.apiService.post('setCache', request).subscribe();
    }
}
